import CalendarToday from "@material-ui/icons/CalendarToday";
import * as React from "react";
import DatePicker, { setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import i18n from "Translations/i18n";
import styles from "./Datepicker.scss";

interface IProps {
    selectedDate?: Date;
    className?: string;
    inputClassName?: string;
    disabled?: boolean;
    onChange: (newDate?: Date) => void;
}

interface IState {
    selectedDate?: Date;
    previousPropDate?: Date;
}

class Datepicker extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedDate: props.selectedDate,
            previousPropDate: props.selectedDate
        };

        this.setLocale();
        this.dateChanged = this.dateChanged.bind(this);
    }

    private setLocale() {
        // https://whyellow.atlassian.net/browse/EZ-226
        // Not working for now
        // registerLocale("nl", nl);
        setDefaultLocale("en");
    }

    public dateChanged(newDate?: Date) {
        if (newDate) {
            newDate = new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), 0, 0, 0, 0));
        }

        this.props.onChange(newDate);
        this.setState({ selectedDate: newDate });
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const state: Partial<IState> = {};

        if (nextProps.selectedDate !== prevState.previousPropDate) {
            if (nextProps.selectedDate !== prevState.selectedDate) {
                state.selectedDate = nextProps.selectedDate;
            }
            state.previousPropDate = nextProps.selectedDate;
        }

        return state;
    }

    public render() {
        return (
            <div className={`${styles.datepickerWrapper} ${this.props.className} ${this.props.disabled ? styles.disabled : null}`}>
                <CalendarToday className={styles.icon} />
                <DatePicker
                    className={`${styles.dateInput} ${this.props.inputClassName}`}
                    selected={this.state.selectedDate}
                    onChange={this.dateChanged}
                    locale="en"
                    dateFormat={i18n.t("datepicker.format")}
                    disabled={this.props.disabled}
                    placeholderText={i18n.t("datepicker.selectDate")} />
            </div>
        );
    }
}

export default Datepicker;


// WEBPACK FOOTER //
// ./src/Components/Datepicker/Datepicker.tsx